var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.8L12 13.4059M12 13.4059L12 10.0118M12 13.4059L8.60587 13.4059M12 13.4059L15.3941 13.4059M2.40093 17.541L2.40102 8.41667C2.40102 7.50275 2.40068 6.20102 2.40039 5.25847C2.40019 4.59555 2.93752 4.05878 3.60044 4.05878H9.31865L12.0837 7.01241H20.4C21.0627 7.01241 21.6 7.54969 21.6 8.21245L21.5997 17.5411C21.5996 18.8666 20.5251 19.9411 19.1997 19.941L4.80092 19.941C3.47543 19.941 2.40091 18.8665 2.40093 17.541Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.5c98ced2ba68979c8b1981421128e4af.svg";
export { ForwardRef as ReactComponent };